<script lang="ts">
  import { isMobileWidth } from '../../../../common/util';
  import BlogDetailCentreVariant from './BlogDetailCentreVariant.svelte';
  import BlogDetailMobileVariant from './BlogDetailMobileVariant.svelte';
  import BlogDetailVariant from './BlogDetailVariant.svelte';

  export let blogDetailData;

  const isResponsive = isMobileWidth();

  function getComponentData(content) {
    const blogDetailComponentData = {
      component: null,
      componentData: null,
    };
    if (content.designType === 'Right') {
      blogDetailComponentData.component = isResponsive ? BlogDetailMobileVariant : BlogDetailVariant;
      blogDetailComponentData.componentData = content;
    } else if (content.designType === 'Left') {
      blogDetailComponentData.component = isResponsive ? BlogDetailMobileVariant : BlogDetailVariant;
      blogDetailComponentData.componentData = content;
    } else if (content.designType === 'Center') {
      blogDetailComponentData.component = isResponsive ? BlogDetailMobileVariant : BlogDetailCentreVariant;
      blogDetailComponentData.componentData = content;
    }
    return blogDetailComponentData;
  }
</script>

{#if blogDetailData}
  <section class="blog-detail-page-section">
    {#if blogDetailData && blogDetailData?.content && blogDetailData?.content.length}
      {#each blogDetailData?.content as content}
        {@const { component, componentData } = getComponentData(content)}
        <svelte:component this={component} data={componentData} />
      {/each}
    {/if}
  </section>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .blog-detail-page-section {
    display: flex;
    flex-direction: column;
    gap: 70px;
    @include desktop-max-width {
      gap: 40px;
    }
  }
</style>
